<template>
  <div class="d-flex col justify-content-end">
    <checkbox-group v-model="state">
      <checkbox
        class="ml-4 mr-0"
        v-for="(state, key) in status"
        :key="key"
        :label="state.state"
      >
        {{ state.name }}
      </checkbox>
    </checkbox-group>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        state: []
      }
    },
    computed: {
      status() {
        return [
          {
            name: this.$t('autocaller_v2.monitoring.rooms.state.ready'),
            state: 'ready'
          },
          {
            name: this.$t('autocaller_v2.monitoring.rooms.state.busy'),
            state: 'busy'
          },
          {
            name: this.$t('autocaller_v2.monitoring.rooms.state.pending'),
            state: 'pending'
          },
          {
            name: this.$t('autocaller_v2.monitoring.rooms.state.empty'),
            state: 'empty'
          }
        ]
      } 
    },
    watch: {
      state: {
        handler() {
          this.$emit('filter', this.state)
        },
        immediate: true
      }
    }
  }
</script>
